import React from 'react';
import FitnessProfileSectionCard from '../shared/FitnessProfileSectionCard';
import FitnessProfileReadingActions from '../shared/FitnessProfileReadingActions';
import FitnessProfileBloodPressureLineChart from '../FitnessProfileBloodPressureLineChart';

export default function FitnessProfileBloodPressureTrackingSection({
	canLogReadings,
	chart,
	bloodPressureGoal,
	onManage,
	onLog
}) {
	return (
		<FitnessProfileSectionCard
			title="Blood Pressure Tracking"
			subtitle="Systolic + diastolic"
			headerAction={
				canLogReadings ? (
					<FitnessProfileReadingActions
						onEdit={onManage}
						onAdd={onLog}
						editAriaLabel="Manage blood pressure readings"
						editTitle="Manage blood pressure readings"
						addAriaLabel="Log blood pressure reading"
						addTitle="Log blood pressure"
					/>
				) : null
			}
		>
			<FitnessProfileBloodPressureLineChart
				data={chart.points}
				trendLine={chart.trendLine}
				bloodPressureGoal={bloodPressureGoal}
			/>
		</FitnessProfileSectionCard>
	);
}
